import React from "react";

import { RightPaneState } from "../../../app/state/right-pane/RightPaneState";
import { useNavigateToLink } from "../../../components/react/link";
import type { MainMenuGroupExtended } from "../../../queries/mainmenu";
import { KUBERNETES_OVERVIEW_PATH, VIEW_PATH } from "../../../routes/Routes";
import { MainMenuItemLayout } from "../MainMenuItemLayout";

export interface MainMenuExtensionProps {
	group: MainMenuGroupExtended;
}

export const MainMenuExtension: React.FC<MainMenuExtensionProps> = ({ group }) => {
	const k8sOverviewLink = useNavigateToLink(KUBERNETES_OVERVIEW_PATH, {
		search: ["timeRange", "timestamp", "detachedFilters"],
	});

	return (
		<MainMenuItemLayout
			data-testid="main-menu-extension"
			defaultOpen={group.defaultOpen}
			icon={group.icon ? <img alt="" src={group.icon} /> : null}
			label={group.name}
			to={group.isKubernetes ? k8sOverviewLink : undefined}
		>
			{group.items.map(({ identifier, title, icon }) => (
				<MenuItem icon={icon} key={identifier} title={title} viewIdentifier={identifier} />
			))}
		</MainMenuItemLayout>
	);
};

const MenuItem: React.FC<{
	viewIdentifier: string;
	title: string;
	icon: string | undefined;
}> = ({ viewIdentifier, title, icon }) => {
	const link = useNavigateToLink(VIEW_PATH, {
		params: { slug: viewIdentifier },
		search: ({ timeRange, timestamp, detachedFilters, rightPane }) => ({
			timeRange,
			timestamp,
			detachedFilters,
			rightPane: RightPaneState.resetWhenVisible(rightPane),
		}),
	});

	return (
		<MainMenuItemLayout
			data-testid="main-menu-extension-item"
			disabled={false}
			icon={icon ? <img alt="" src={icon} /> : null}
			label={title}
			level={1}
			to={link}
		/>
	);
};
